import { render, staticRenderFns } from "./parent_create.vue?vue&type=template&id=665a2298&"
import script from "./parent_create.vue?vue&type=script&lang=js&"
export * from "./parent_create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports